import React from 'react';
import axios from 'axios'
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import {Button, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";

import Table from "../../components/Table/index";

class AdminList extends React.Component {
    constructor(props) {
        super(props);

        moment.locale('cs');

        const tooltipEdit = (
            <Tooltip id="tooltip-edit">Upravit</Tooltip>
        );
        const tooltipRemove = (
            <Tooltip id="tooltip-remove">Odstranit</Tooltip>
        );

        const columns = [{
            Header: 'Jméno a přijmení',
            accessor: 'fullname',
        }, {
            Header: 'Přezdívka',
            accessor: 'nickname'
        },{
            Header: 'Email',
            accessor: 'email',
        },{
            Header: 'Telefon',
            accessor: 'phoneNumber',
        },{
            Header: 'Možnosti',
            style: {padding: '0px'},
            filterable: false,
            Cell: row => {
                return (
                    <div className="row-menu">
                        <OverlayTrigger placement="top" overlay={tooltipEdit}>
                            <Link to={`/admins/edit/${row.original.id}`}>
                                <FontAwesome name="pencil-square-o" className="cursor-p" />
                            </Link>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={tooltipRemove}>
                            <FontAwesome name="trash" onClick={() => this.showModal(row.original)} className="cursor-p"/>
                        </OverlayTrigger>
                    </div>
                );
            }
        }];

        this.state = {
            admins: [],
            columns: columns,
            tableOptions: [],
            removeAdmin: null,
            showModal: false
        };

        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount () {
        this.getAdmins();
    }

    getAdmins() {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        this.setState({
            tableOptions: {
                ...this.state.tableOptions,
                loading: true
            }
        });
        axios.get(this.props.api.users, config)
        .then((result) => {
            if (!this._calledComponentWillUnmount) {
                let admins = result.data.map((elem) => {
                    elem.lastLogin = moment(elem.lastLogin).format('LLLL');
                    elem.fullname = (elem.firstname && elem.surname) ? elem.firstname + ' ' + elem.surname : '';
                    return elem;
                });
                admins = admins.filter((elem) => elem.role === 'admin');
                this.setState({
                    admins,
                    tableOptions: {
                        ...this.state.tableOptions,
                        loading: false
                    }
                });
            }
        }).catch((error) => {
            console.error('Axios error:', error);
        });
    }

    closeModal() {
        this.setState({
            showModal: false,
            removeAdmin: null
        })
    }

    showModal(admin) {
        this.setState({
            showModal: true,
            removeAdmin: admin
        })
    }

    render () {
        let {removeAdmin} = this.state;
        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Seznam administrátorů</h2>
                    <Button className="btn-success btn-add" onClick={() => this.props.history.push('/admins/add')}>
                        <FontAwesome name="plus"/>
                    </Button>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    <Table
                        columns={this.state.columns}
                        data={this.state.admins}
                        tableOptions={this.state.tableOptions}
                        defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
                    />
                </div>
                {
                    removeAdmin &&
                    <Modal show={this.state.showModal} onHide={this.closeModal} backdrop='static'>
                        <Modal.Header closeButton className="text-danger bg-danger">
                            <Modal.Title>Odstranění administrátora</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Opravdu chcete odstranit administrátora: {removeAdmin.firstname} {removeAdmin.surname}?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.closeModal}>Zrušit</Button>
                            <Button className='btn btn-danger' onClick={() => this.props.handleRemoveAdmin(removeAdmin)}>Odstranit</Button>
                        </Modal.Footer>
                    </Modal>
                }
            </div>
        );
    }
}

export default withRouter(AdminList);



/** WEBPACK FOOTER **
 ** ./src/containers/Admins/AdminList.js
 **/